/**
 * Project panel
 *
 * Created by stefensuhat on 13/08/18 6.56 PM
 */

import { Button, CircularProgress, Fab, makeStyles } from '@material-ui/core';
import cx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

const styles = makeStyles(({ transitions, spacing, palette }) => ({
    contained: (props) => ({
        '&:disabled': {
            backgroundColor: palette[props.color].main,
            color: 'white',
        },
    }),
    progress: {
        marginLeft: (props) => (props.loading ? spacing(1.5) : spacing(0)),
        transition: transitions.create(['margin-left'], {
            duration: transitions.duration.shortest,
            easing: transitions.easing.easeInOut,
        }),
    },
}));


function LoadingButton(p) {
    const {
        fab, label, loading, children, disabled, variant, className, loadingLabel, color, ...props
    } = p;
    const classes = styles({ color, loading });

    const buttonProps = {
        ...props,
        color,
        disabled: loading || disabled,
        className: cx(
            className,
            classes.button,
        ),

    };

    if (fab) {
        return (
            <Fab
                {...buttonProps}
                variant={variant}
            >
                {children}
                {loading && <CircularProgress color="white" size={18} />}
            </Fab>
        );
    }

    return (
        <Button
            {...buttonProps}
            classes={{
                contained: classes.contained,
            }}
            variant={loading ? 'contained' : variant}
        >
            {children}
            {loading && <CircularProgress color="white" size={18} className={classes.progress} />}
        </Button>

    );
}


const propTypes = {
    loading: PropTypes.bool,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    fab: PropTypes.bool,
    color: PropTypes.oneOf('primary', 'secondary'),
};
const defaultProps = {
    color: 'primary',
    disabled: false,
    fab: false,
    label: '',
    loading: false,
};

LoadingButton.propTypes = propTypes;
LoadingButton.defaultProps = defaultProps;

export default LoadingButton;
